import * as React from "react";
import { forwardRef } from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Check Icon/Cross" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M21.5984 10.4004L10.3984 21.6004M21.5984 21.6004L10.3984 10.4004L21.5984 21.6004Z", stroke: "#BDBDBD", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
